module.exports = __webpack_public_path__ + "img/ios-download.230ca725.png";